import React from 'react';

import { IonItem } from '@ionic/react';

import { Virtuoso } from 'react-virtuoso';

import ListItem from 'components/ListItem';
import Typography from 'components/Typography';

import { DataListConfig } from './interfaces';

// Virtuoso's resize observer can this error,
// which is caught by DnD and aborts dragging.
window.addEventListener('error', e => {
  if (
    e.message ===
      'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
  }
});

// @ts-ignore
window.VIRTUOSO_LOG_LEVEL = 4;

export const DataList: React.FC<DataListConfig> = ({
  data,
  virtualized = true,
  isSelected,
  onItemClick,
  getLabel,
  getBadge,
  secondaryActions,
  primaryActions,
}) => {
  if (!data?.length) {
    return (
      <IonItem>
        <Typography>No results</Typography>
      </IonItem>
    );
  }

  if (!virtualized) {
    return data?.map((option: any, i: number) => (
      <ListItem
        key={i}
        option={option}
        isSelected={isSelected}
        onItemClick={onItemClick}
        getLabel={getLabel}
        getBadge={getBadge}
        secondaryActions={secondaryActions}
        primaryActions={primaryActions}
      />
    ));
  }

  return (
    <>
      <Virtuoso
        totalCount={data.length}
        itemContent={index => (
          <ListItem
            option={data[index]}
            isSelected={isSelected}
            onItemClick={onItemClick}
            getLabel={getLabel}
            getBadge={getBadge}
            secondaryActions={secondaryActions}
            primaryActions={primaryActions}
          />
        )}
      />
    </>
  );
};
